<template>
  <el-row class="hidden-md-and-down">
    <el-col :span="this.isManager() ? 18 : 24" v-if="this.rowData.organisation">
      <contacts-popover :row-data="rowData" />
    </el-col>

    <el-col v-show="this.isSuper()" :span="4">
      <el-button v-show="isSuper()" icon="fa fa-trash-alt" @click="deleteEntry()" size="small" type="danger" circle></el-button>
    </el-col>
  </el-row>
  </template>

  <script>

  import PostMixins from '@/mixins/PostMixins'
  import ContactsPopover from '@/components/atoms/ContactsPopover'

  export default {
    mixins: [PostMixins],

    components: {
      ContactsPopover
    },

    props: {

      rowData: {
        type: Object,
        required: true
      },

      tableRef: {
        type: String,
        default: 'progress-table'
      }

    },

    methods: {

      deleteEntry () {
        this.deleteItem(this, this.rowData.id, '/actions',
        this.rowData.summary,
        this.onDelete)
      },

      onDelete (response) {
        this.$events.emit(this.tableRef + '-refresh-table')
        this.$emit('update-stats')
      }

    }

  }
  </script>
